export interface GeneralState {
  zoomImageUrl: string | null
}

const initialState: GeneralState = {
  zoomImageUrl: null,
}

export default initialState
